import { render, staticRenderFns } from "./MainNavigationButton.vue?vue&type=template&id=5b932086"
import script from "./MainNavigationButton.vue?vue&type=script&lang=js"
export * from "./MainNavigationButton.vue?vue&type=script&lang=js"
import style0 from "./MainNavigationButton.vue?vue&type=style&index=0&id=5b932086&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports